const strapiConfig = {
  version: 5,
  apiURL: process.env.API_BASE_URL,
  accessToken: process.env.API_TOKEN,
  collectionTypes: [
    {
      singularName: 'toolkit-module',
      queryParams: {
        populate: {
          facilitator_guide: { populate: '*' },
          presentation: { populate: '*' },
          powerpoint: { populate: '*' },
          full_module: { populate: '*' },
          thumbnail: { populate: '*' },
        },
      },
    },
    {
      singularName: 'topic',
      queryParams: {
        status: 'published',
        populate: {
          thumbnail: { populate: '*' },
          hero_image: { populate: { background_image: { populate: '*' } } },
          blocks: { populate: '*' },
          resources: { populate: '*' },
          videos_and_webinars: { populate: '*' },
          series: { populate: '*' },
        },
      },
    },
    {
      singularName: 'resource',
      queryParams: {
        status: 'published',
        populate: {
          thumbnail: { populate: '*' },
          image: { populate: '*' },
          pdf: { populate: '*' },
          category: { populate: '*' },
          topics: { populate: '*' },
          series: { populate: '*' },
        },
      },
    },
    {
      singularName: 'video',
      queryParams: {
        status: 'published',
        populate: {
          thumbnail: { populate: '*' },
          image: { populate: '*' },
          transcript: { populate: '*' },
          video_category: { populate: '*' },
          topics: { populate: '*' },
          category: { populate: '*' },
          series: { populate: '*' },
        },
      },
    },
    {
      singularName: 'category',
    },
    {
      singularName: 'video-category',
    },
    {
      singularName: 'event',
      queryParams: {
        status: 'published',
        // Ships every not-yet-ended event, regardless of how far in the
        // future it starts — deciding which one (if any) is currently
        // within its lead time to be Featured happens client-side instead
        // (see useCurrentEvent), using the visitor's own clock. An event
        // excluded here could never appear later without a rebuild, so
        // this can't apply the lead-time cutoff itself; only "already
        // ended" is safe to exclude at the source, since that can never
        // become false again.
        filters: {
          end_datetime: { $gt: new Date().toISOString() },
        },
        // Soonest-starting first, so useCurrentEvent can just take the
        // first qualifying one.
        sort: ['start_datetime:asc'],
        populate: {
          image: { populate: '*' },
          registration_link: { populate: '*' },
        },
      },
    },
    {
      singularName: 'serie',
      queryParams: {
        status: 'published',
        populate: {
          thumbnail: { populate: '*' },
          image: { populate: '*' },
          hero_image: { populate: { background_image: { populate: '*' } } },
          category: { populate: '*' },
          topics: { populate: '*' },
          resources: { populate: '*' },
          videos_webinars_series: { populate: '*' },
        },
      },
    },
  ],
  singleTypes: [
    {
      singularName: 'home',
      queryParams: {
        populate: {
          topics: { populate: '*' },
          // featured is a dynamic zone identical in shape/components to
          // whats_new below, truncated to 1 item in Home.js.
          featured: { populate: '*' },
          // DEV: whats_new is a dynamic zone allowing 3 different component
          // types. A raw curl straight to Strapi confirmed the documented
          // per-component populate ("on" syntax, naming each component's own
          // relation field) works correctly server-side — but gatsby-source-
          // strapi's own request still resolved this field to null, which
          // points at the plugin's own populate-object-to-query-string
          // serialization mishandling this deeply nested structure (dynamic
          // keys nested several levels deep, including component UIDs
          // containing dots/hyphens as object keys). Trying the flatter
          // populate: '*' instead, now that the real blocker (the missing
          // Gatsby schema type for this field) is fixed separately in
          // gatsby-node.js — this already works for blocks/highlighted-
          // resources elsewhere, a single-component dynamic zone, so if it
          // doesn't fully populate each component's relation here either,
          // that'll tell us the multi-component case needs the "on" syntax
          // and this plugin just can't serialize it — a real limitation to
          // work around (e.g. a custom sourceNodes fetch) rather than a
          // config mistake.
          whats_new: { populate: '*' },
        },
      },
    },
    {
      singularName: 'about',
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: '*' } } },
          blocks: { populate: '*' },
        },
      },
    },
    {
      singularName: "federal-sponsor",
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: "*" } } },
        },
      },
    },
    {
      singularName: "contractor-acknowledgments-page",
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: "*" } } },
        },
      },
    },
    {
      singularName: "explore-topic",
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: '*' } } },
          blocks: { populate: '*' },
        },
      },
    },
    {
      singularName: 'videopage',
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: '*' } } },
          blocks: { populate: '*' },
        },
      },
    },
    {
      singularName: "idta-page",
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: "*" } } },
          blocks: { populate: "*" },
          resources: { populate: "*" },
          videos_and_webinars: { populate: '*' },
          series: { populate: '*' },
          image: { populate: "*" },
          idta_files: { populate: "*" },
        },
      },
    },
    {
      singularName: "rpg-program-page",
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: "*" } } },
          blocks: { populate: "*" },
          resources: { populate: "*" },
          videos_and_webinars: { populate: '*' },
          series: { populate: '*' },
          image: { populate: "*" },
          rpg_files: { populate: "*" },
        },
      },
    },
    {
      singularName: "key-legislation",
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: "*" } } },
          blocks: { populate: "*" },
          resources: { populate: "*" },
          videos_and_webinars: { populate: '*' },
        },
      },
    },
    {
      singularName: "technical-assistance-page",
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: "*" } } },
          resources: { populate: "*" },
          image: { populate: "*" },
          videos_and_webinars: { populate: '*' },
        },
      },
    },
    {
      singularName: "statistics-page",
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: "*" } } },
          resources: { populate: "*" },
        },
      },
    },
    {
      singularName: 'training-tool-kit',
      queryParams: {
        populate: {
          hero_image: { populate: { background_image: { populate: '*' } } },
          resources: { populate: "*" },
          glossary: { populate: "*" },
          full_toolkit: { populate: "*" },
        },
      },
    },
  ],
};

module.exports = {
  trailingSlash: 'always',
  siteMetadata: {
    siteUrl: 'https://ncsacw.acf.gov/',
    author: 'National Center on Substance Abuse and Child Welfare',
    title: 'National Center on Substance Abuse and Child Welfare',
    description:
      'NCSACW is a national resource center providing information, expert consultation, training and technical assistance to child welfare, dependency court and substance use treatment professionals to improve the safety, permanency, well-being and recovery outcomes for children, parents and families.',
    navigation: [
      {
        title: 'Home',
        link: '/',
        items: [{ text: 'Home', link: '/' }],
      },
      {
        title: 'Explore Topics',
        link: '/topics',
        items: [
          { text: 'CAPTA Plans of Safe Care', link: '/' },
          { text: 'Childhood and Adolescence', link: '/'},
          { text: 'Drug Testing', link: '/' },
          { text: 'Infants', link: '/' },
          { text: 'Peer and Recovery Specialists', link: '/' },
          { text: 'Pregnancy', link: '/' },
          { text: 'Safety and Risk', link: '/' },
          { text: 'Substance-Specific Resources', link: '/' },
          { text: 'Trauma-Informed Care', link: '/' },
          { text: 'Working with American Indian/Alaska Native Families and Communities', link: '/'}
        ],
      },
      {
        title: 'Research',
        link: '/research',
        items: [
          { text: 'Child Welfare and Substance Use Disorder Treatment Statistics', link: '/research/child-welfare-statistics' },
          { text: 'Interactive Bibliography', link: '/research/bibliography' },
          { text: 'Key Legislation', link: '/research/key-legislation' }
        ],
      },
      {
        title: 'Training',
        link: '/training',
        items: [
          { text: 'Child Welfare Training Toolkit', link: '/training/toolkit' },
          { text: 'Online Tutorials', link: '/training/tutorials' },
          { text: 'Videos and Webinars', link: '/training/videos-and-webinars' }
        ],
      },
      {
        title: 'Technical Assistance',
        link: '/technical',
        items: [
          { text: 'Family-Centered Systems Innovation Team', link: '/technical/idta' },
          { text: 'Regional Partnership Grants Program', link: '/technical/rpg' }
        ],
      },
      {
        title: 'About Us',
        link: '/about-us',
        items: [{ text: 'About Us', link: '/about-us' }],
      },
    ],

    /**
     * Search.gov configuration
     *
     * 1. Create an account with Search.gov https://search.usa.gov/signup
     * 2. Add a new site.
     * 3. Add your site/affiliate name here.
     */
    searchgov: {
      // Only change this if you're using a CNAME. Learn more here: https://search.gov/manual/cname.html
      endpoint: 'https://search.usa.gov',

      // Replace this with your search.gov site handle.
      affiliate: 'ncsacw-acf',

      // Replace this with your access key.
      access_key: 'rxtyEl2tSlk5oKuRA6mxseBdkscJdGIQyKai7DUoeSE=',

      // This renders the results within the page instead of sending to user to search.gov.
      inline: true,

      // This allows Search.gov to present relevant type-ahead search suggestions in your website's search box.
      // If you do not want to present search suggestions, set this value to false.
      suggestions: true,
    },

    /**
     * Digital Analytics Program (DAP) configuration
     *
     * USAID   - Agency for International Development
     * USDA    - Department of Agriculture
     * DOC     - Department of Commerce
     * DOD     - Department of Defense
     * ED      - Department of Education
     * DOE     - Department of Energy
     * HHS     - Department of Health and Human Services
     * DHS     - Department of Homeland Security
     * HUD     - Department of Housing and Urban Development
     * DOJ     - Department of Justice
     * DOL     - Department of Labor
     * DOS     - Department of State
     * DOI     - Department of the Interior
     * TREAS   - Department of the Treasury
     * DOT     - Department of Transportation
     * VA      - Department of Veterans Affairs
     * EPA     - Environmental Protection Agency
     * EOP     - Executive Office of the President
     * GSA     - General Services Administration
     * NASA    - National Aeronautics and Space Administration
     * NARA    - National Archives and Records Administration
     * NSF     - National Science Foundation
     * NRC     - Nuclear Regulatory Commission
     * OPM     - Office of Personnel Management
     * USPS    - Postal Service
     * SBA     - Small Business Administration
     * SSA     - Social Security Administration
     */
    dap: {
      // agency: 'your-agency',
      // Optional
      // subagency: 'your-subagency',
    },
    gtm: {
      id: "GTM-P2QHP335"
    },

    /**
     * Google Analytics configuration
     */
    ga: {
       ua: 'GTM-TMDHTLQ',
    },
    crazyegg: {
      url: "https://script.crazyegg.com/pages/scripts/0132/7565.js"
    }
  },
  pathPrefix: process.env.BASEURL || '/',
  plugins: [
    {
      resolve: 'gatsby-source-strapi',
      options: strapiConfig,
    },
    'gatsby-plugin-postcss',
    'gatsby-plugin-image',
    'gatsby-plugin-sharp',
    'gatsby-transformer-sharp',
    'gatsby-plugin-root-import',
    'gatsby-plugin-sass',
    `gatsby-plugin-styled-components`,
    {
      resolve: `gatsby-plugin-schema-snapshot`,
      options: {
        // Path where the type definitions will be saved to
        path: `src/schema/schema.gql`,
        // ensure all field types are included
        // don't turn this off unless you have a very good reason to
        withFieldTypes: true,
        // manually control if a saved schema snapshot should be replaced with an
        // updated version
        update: false,
      },
    },
    {
      resolve: `gatsby-transformer-json`,
      options: {
        typeName: ({ node }) => {
          return node.relativePath.split('.').slice(0, -1).join('.')
        }
      }
    },
    'gatsby-plugin-react-helmet',
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'images',
        path: `${__dirname}/src/assets/images`,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'blog-posts',
        path: `${__dirname}/src/blog-posts`,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'documentation-pages',
        path: `${__dirname}/src/documentation-pages`,
      },
    },
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'data',
        path: `${__dirname}/src/data`,
      },
    },
    'gatsby-transformer-remark',
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        name: 'gatsby-starter-default',
        short_name: 'starter',
        start_url: '/',
        background_color: '#fff',
        theme_color: '#fff',
        display: 'minimal-ui',
        icon: 'src/assets/images/favicon.png', // This path is relative to the root of the site.
      },
    },
    {
      resolve: `gatsby-plugin-sitemap`,
      options: {
        output: `/sitemap`, // Sets custom path for the sitemap index file
      }
    },
    {
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: 'https://ncsacw.acf.gov',
         sitemap: 'https://ncsacw.acf.gov/sitemap/sitemap-0.xml',
         policy: [{ userAgent: '*', allow: '/' }]
      },
    },
    {
      resolve: 'gatsby-plugin-react-svg',
      options: {
        rule: {
          include: /\.inline\.svg$/,
        },
      },
    },
    `gatsby-plugin-meta-redirect`
  ],
};
